import { Sparkles } from 'lucide-react'
import type { ButtonHTMLAttributes } from 'react'
import { Spinner } from '../Spinner'

interface GenerateButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isGenerating?: boolean
  generateLabel?: string
  generatingLabel?: string
}

export function GenerateButton({
  isGenerating = false,
  generateLabel = 'Generate',
  generatingLabel = 'Generating...',
  className = '',
  ...props
}: GenerateButtonProps) {
  return (
    <button
      type="button"
      disabled={isGenerating || props.disabled}
      className={className}
      {...props}
    >
      {isGenerating ? (
        <span className="flex items-center justify-center gap-1.5">
          <Spinner size="xs" />
          {generatingLabel}
        </span>
      ) : (
        <span className="flex items-center justify-center gap-1.5">
          {generateLabel}
          <Sparkles className="h-3.5 w-3.5" />
        </span>
      )}
    </button>
  )
}
